import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { SpeedInsights } from "@vercel/speed-insights/react";



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<App />
		<SpeedInsights />
	</React.StrictMode>
);

